/**
 * Formats a date to MM/DD format
 * @param date - Date object or date string
 * @returns Formatted date string like "02/10" or null if invalid
 */
export function formatShortDate(
  date: Date | string | null | undefined
): string | null {
  if (!date) return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;

  return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
    d.getDate()
  ).padStart(2, "0")}`;
}
